export const exchanges = {
  tjDex:
    "https://traderjoexyz.com/#/trade?inputCurrency=0x130966628846bfd36ff31a822705796e8cb8c18d&outputCurrency=0x942f53a16bf2D1aa650fd456BDbB352A22B7b356",
};
